import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import '../styles/Schedule.css';
const Schedule = () => {
  return (
 <Tabs>
   <TabList className="tab-list">
     <Tab style={{ color: 'rgb(32, 121, 175)', width: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'Poppins'}} >UMD Schedule</Tab>
     <Tab  style={{color: 'rgb(32, 121, 175)', width: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'Poppins'}}>USC Schedule</Tab>
   </TabList>
{/* UMD Schedule Tab */}
   <TabPanel>
   <h3 class="day" style = {{marginTop: '40px'}}> Friday,</h3>
   <h5 class="date"> September 12</h5>
   <div className="container">
       <div class="bluerectangle">
         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             General Registration <br/>
           </p>
           <p class="bodytext" >
             12:00 - 1:00pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Arts Impact! Art's Unique Capacity for Innovation, Community, and Change <br/>
             Alexander Golob
           </p>
           <p class="bodytext" >
             2:00 - 2:25pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Keynote: Nicole Yunger Halpern <br/>
           </p>
           <p class="bodytext" >
             2:30 - 3:15pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Bruce Rosenbaum <br/>
           </p>
           <p class="bodytext" >
             3:20 - 4:05pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Snack Break <br/>
           </p>
           <p class="bodytext" >
             4:05 - 4:35pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Quantum Choreographies <br/>
             Featuring Carl A. Miller, Adriane Fang, and Kevin Clark
           </p>
           <p class="bodytext" >
             4:40 - 4:55pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Science & Music of the Bloch Sphere<br/>
             Featuring Lucy Liuxuan Zhang, Eric Huang, and Marcello Silva
           </p>
           <p class="bodytext" >
             4:55 - 5:20pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>
        
        <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Live Q&A <br/>
             Quantum Choreographies + Science & Music of the Bloch Sphere
           </p>
           <p class="bodytext" >
             5:20 - 6:00pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{ margin: '15px', marginLeft: '15px'}}>
             Closing + Challenges Intro<br/>
           </p>
           <p class="bodytext" >
             6:00 - 6:10pm
             <br /> Stamp Student Union
             <br /> Hoff Theatre
           </p>
         </div>
       </div>
   </div>

   <h3 class="day" style={{marginTop: '40px'}}> Saturday,</h3>
   <h5 class="date"> September 13</h5>
   <div class="container">
   <div class="bluerectangle" style={{marginBottom: '40px'}}>
         <div class="whiterectangle">
           <p style={{ margin: '15px'}} >
             Breakfast & General Registration<br />
           </p>
           <div class="bodytext">
               <p>8:00 - 9:00am </p>
               <p>Stamp Student Union </p> 
               <p>Colony Ballroom</p>
           </div>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Quantum Creativity<br />
             Quantum Village<br />
             Victoria Kumaran & Mark Carney
           </p>
           <p class="bodytext">
             9:00 - 9:30AM<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Manim Workshop<br />
             Jonathan Waldorf
           </p>
           <p class="bodytext">
             9:30 - 10:30am<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
            Quantum Intuition XR: tangible quantum mechanics in virtual reality<br />
             Myungin Lee
           </p>
           <p class="bodytext">
             10:30 - 10:50am<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Snack Break
           </p>
           <p class="bodytext">
             10:50 - 11:00am<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Comic Making Workshop<br />
             Daniel Serrano & Amelie Wang
           </p>
           <p class="bodytext">
             11:00 - 1:20pm<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Lunch
           </p>
           <p class="bodytext">
             12:45 - 2:00pm<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Exhibitions<br />
             Quantum Intuition, LiteraryDJ, and Quantum Village
           </p>
           <p class="bodytext">
             1:20 - 2:00pm<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Blender Workshop<br />
             Onri Jay Benally
           </p>
           <p class="bodytext">
             2:00 - 3:50pm<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Keynote: Scott Oshiro<br />
           </p>
           <p class="bodytext">
             3:50 - 4:50pm<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Closing Remarks & Merch Distribution
           </p>
           <p class="bodytext">
             4:50 - 5:00pm<br />
             Stamp Student Union <br />
             Colony Ballroom
           </p>
         </div>

         
       </div>
   </div>
   </TabPanel>
{/* USC Schedule Tab */}
   <TabPanel>
   <h3 class="day" style={{marginTop: '40px'}}> Friday,</h3>
   <h5 class="date"> September 12</h5>
   <div className="container">
       <div class="bluerectangle">
         <div class="whiterectangle">
           <p style={{ margin: '15px'}}>
             Welcome Reception <br/>
             and Check-in<br />
           </p>
           <p class="bodytext" >
             6 - 8:30 pm
             <br /> Location: Michelson Hall 101, 1002 Childs Way, Los Angeles, CA 90089
           </p>
         </div>
       </div>
   </div>

      <h3 class="day" style={{marginTop: '40px'}}> Saturday,</h3>
   <h5 class="date"> September 13</h5>
   <div className="container">
       <div class="bluerectangle">
         <div class="whiterectangle">
           <p style={{ margin: '15px'}}>
            Last Qomputing Day!<br />
           </p>
           <p class="bodytext" >
             All day
             <br /> Location: virtual
           </p>
         </div>
       </div>
   </div>

   <h3 class="day" style={{marginTop: '40px'}}> Sunday,</h3>
   <h5 class="date"> September 14</h5>
   <div class="container">
   <div class="bluerectangle" style={{marginBottom: '40px'}}>
         <div class="whiterectangle">
           <p style={{ margin: '15px'}} >
             Check-in<br />
           </p>
           <div class="bodytext">
               <p>11 - 11:20 am </p>
               <p>Location: Michelson Hall 101, 1002 Childs Way, Los Angeles, CA 90089</p>
           </div>
         </div>
         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Keynote 1: The Road to Success in Quantum is Nonlinear by Adrian Acosta<br />
           </p>
           <p class="bodytext">
             11:30 am - 12:30 pm <br />
             Location: Michelson Hall 101
           </p>
         </div>
         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Lunch
           </p>
           <p class="bodytext">
             12:30 - 1:30 pm <br />
             Location: Michelson Hall 101
           </p>
         </div>
         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Keynote 2: Anticipating the Social Impacts of Quantum Innovation by Kate Pundyk
           </p>
           <p class="bodytext">
             1:30 - 2:30 pm <br />
             Location: Michelson Hall 101
           </p>
         </div>
         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Networking, snack, and photo booth break
           </p>
           <p class="bodytext">
             2:30 - 3 pm <br />
             Location: Michelson Hall 101
           </p>
         </div>
         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             A Holistic View of Quantum: The science, Policy, and Economics
           </p>
           <p class="bodytext">
             3 - 4:30 pm <br />
             Location: Michelson Hall 101
           </p>
         </div>
         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Winners, prizes, and closing remarks 
           </p>
           <p class="bodytext">
             4:30 - 5 pm <br />
             Location: Michelson Hall 101
           </p>
         </div>
         <div class="whiterectangle">
           <p style={{margin: '15px'}}>
             Closing dinner reception
           </p>
           <p class="bodytext">
             5 - 7 pm <br />
             Location: Michelson Hall Patio
           </p>
         </div>
       </div>
   </div>
  
   </TabPanel>
 </Tabs>
);
};
export default Schedule;